module.exports = __webpack_public_path__ + "img/boky_08_reflexni-cervena.89cd3572.png";